"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
class TrialsMeta {
    constructor(data = {
        name: '',
        approvedAt: '',
        totalSamples: 0,
        totalAssignedSamples: 0,
        crop: { id: 0, logoName: '', name: '' },
    }) {
        this.name = data.name;
        this.approvedAt = data.approvedAt;
        this.totalSamples = data.totalSamples;
        this.totalAssignedSamples = data.totalAssignedSamples;
        this.crop = data.crop;
    }
    get collectName() {
        return this.name;
    }
    get collectApprovedAt() {
        return this.approvedAt;
    }
    get collectTotalSamples() {
        return this.totalSamples;
    }
    get collectTotalAssignedSamples() {
        return this.totalAssignedSamples;
    }
    get collectCropObject() {
        return this.crop;
    }
}
exports.default = TrialsMeta;
